module.exports = __webpack_public_path__ + "src/assets/images/login//Specifications.jpeg";